import { BASIS_POINTS } from "./evmGasPolicies.js";
export const applyGasLimitMargin = (estimatedGas, policy) => (estimatedGas * policy.gasLimitMarginBps + BASIS_POINTS - 1n) / BASIS_POINTS;
const EIP7702_DELEGATION_DESIGNATOR = /^0xef0100[0-9a-f]{40}$/i;
export const isEIP7702DelegatedCode = (accountCode) => accountCode !== undefined && EIP7702_DELEGATION_DESIGNATOR.test(accountCode);
export const resolveAccountBalanceReserve = ({ policy, accountCode, }) => {
    const reserve = policy.accountBalanceReserve;
    if (!reserve)
        return 0n;
    switch (reserve.condition) {
        case 'eip7702-delegated':
            return isEIP7702DelegatedCode(accountCode) ? reserve.amount : 0n;
    }
};
/** Use the same required fee fields for gas estimates and sending. */
const resolveExplicitTransactionFees = ({ policy, gasPrice, maxFeePerGas, maxPriorityFeePerGas }) => {
    if (policy.transactionGasMode === 'explicit-legacy') {
        return gasPrice === undefined ? undefined : { gasPrice };
    }
    if (policy.transactionGasMode === 'explicit-eip1559'
        && maxFeePerGas !== undefined && maxPriorityFeePerGas !== undefined) {
        return { maxFeePerGas, maxPriorityFeePerGas };
    }
    return undefined;
};
export const calculateGasFeeAmounts = ({ policy, estimatedGas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, }) => {
    if (policy.transactionGasMode !== 'wallet' && !resolveExplicitTransactionFees({
        policy, gasPrice, maxFeePerGas, maxPriorityFeePerGas,
    })) {
        return undefined;
    }
    const maximumGasPrice = policy.transactionGasMode === 'explicit-legacy'
        ? gasPrice
        : maxFeePerGas ?? gasPrice;
    if (maximumGasPrice === undefined)
        return undefined;
    const gasLimit = applyGasLimitMargin(estimatedGas, policy);
    const expectedGasPrice = policy.feeQuoteMode === 'current-capped' && gasPrice !== undefined
        ? gasPrice < maximumGasPrice ? gasPrice : maximumGasPrice
        : maximumGasPrice;
    return {
        gasLimit,
        estimatedFee: gasLimit * expectedGasPrice,
        maximumFee: gasLimit * maximumGasPrice,
    };
};
export const buildTransactionGasParameters = ({ policy, chainId, estimatedGas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, }) => {
    if (policy.transactionGasMode === 'wallet') {
        return undefined;
    }
    const fees = resolveExplicitTransactionFees({ policy, gasPrice, maxFeePerGas, maxPriorityFeePerGas });
    if (!fees) {
        const message = policy.transactionGasMode === 'explicit-legacy'
            ? 'Legacy gas price is unavailable'
            : 'EIP-1559 fee data is unavailable';
        const chainContext = chainId === undefined ? '' : ` for chain ${chainId}`;
        throw new Error(`${message}${chainContext}`);
    }
    return {
        gas: applyGasLimitMargin(estimatedGas, policy),
        ...fees,
    };
};
